module.exports = __webpack_public_path__ + "img/gold2.b9c8cd5e.png";